<template>
    <div>
        <div>
            <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
            <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
        </div>
        <md-card>
            <md-card-content>
                <md-layout md-gutter>
                    <md-layout md-flex="10">
                        <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="previousPoView">&laquo; Back</md-button>
                    </md-layout>
                    <md-layout md-flex="30"></md-layout>
                    <md-layout md-flex="40" class="mobile-width">
                        <h2>Request For Quotation</h2>
                    </md-layout>
                </md-layout>
                <b-row>
                    <b-col md="3">
                        <label for="location">Location</label>
                        <model-list-select :list="locationMasterList" v-model="stockInDetails.location"
                            option-value="pickupId" option-text="pickupLocation" placeholder="Select Location"
                            :isDisabled="stockInDetails.RQ_ID != ''"></model-list-select>
                    </b-col>
                    <b-col md="3" v-if="itemArrayShow.length > 0">
                        <label>Status :</label><br>
                        <md-switch :id="'approval' + stockInDetails.isReseAndQuoActive" name="approval"
                            class="md-primary" :value="stockInDetails.isReseAndQuoActive == 1 ? true : false"
                            @change="activatestockInDetails()">
                            <h6>
                                <b-badge :variant="
                              stockInDetails.isReseAndQuoActive == 1
                                  ? 'success'
                                  : 'danger'
                              ">{{
                                    stockInDetails.isReseAndQuoActive == 1
                                    ? "Active"
                                    : "In-Active"
                                    }}</b-badge>
                            </h6>
                        </md-switch>
                    </b-col>
                    <b-col md="3"></b-col>
                    <b-col md="3"></b-col>
                </b-row>
                <b-row v-if="stockInDetails.RQ_ID != ''">
                    <b-col md="3" v-if="itemModal.poItemId == ''">
                        <b-row>
                            <b-col md="9">
                                <label for="itemMasterAll">Item Code/Name <span style="color:red;">*</span></label>
                                <model-list-select :list="itemMasterList" v-model="itemMasterAll" option-value="itemId"
                                    option-text="itemNameCode" placeholder="Select Item Code"></model-list-select>
                                <span class="error" v-if="!itemModal.itemName">{{ itemModelErrorList.itemName }}</span>
                            </b-col>
                            <b-col md="3">
                                <b-button variant="primary" @click="openItemModal()" id="addButtonLoader" size="sm"
                                    style="margin-top:40px;">Add</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="3" v-else>
                        <label for="itemMasterAll">Item Code/Name </label>
                        <b-form-input :formatter="capitalizeAll" id="specificPoDetail" name="specificPoDetail"
                            v-model="itemModal.dummyItemName" disabled></b-form-input>
                    </b-col>
                    <b-col md="2">
                        <label>Quantity <span style="color:red;">*</span></label>
                        <b-form-input :formatter="capitalizeAll" id="itemQuantity" name="itemQuantity"
                            v-model="itemModal.itemQuantity" type="number" min="0"></b-form-input>
                        <span class="error" v-if="!itemModal.itemQuantity">{{ itemModelErrorList.itemQuantity }}</span>
                    </b-col>
                    <b-col md="3">
                        <label>Remarks</label>
                        <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks"
                            v-model="itemModal.remarks"></b-form-textarea>
                    </b-col>
                    <b-col md="4">
                        <md-button style="margin-top:28px; text-align:center;"
                            class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="addItem">Add Items</md-button>
                    </b-col>
                </b-row>
                <div style="background:beige">
                    <hr class="hr-s" v-if="itemArrayShow.length > 0" />
                    <div class="box" v-if="itemArrayShow.length > 0">
                        <div class="box-header">
                            <h3 class="box-title">Itemized Stock Details</h3>
                        </div>
                        <div class="box-body table-striped table-responsive">
                            <table id="poTable" class="table table-bordered ">
                                <thead>
                                    <tr>
                                        <th>SN.</th>
                                        <th>Item Name</th>
                                        <th>Quantity</th>
                                        <th>Remarks</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in itemArrayShow" :key="index">
                                        <td>{{index+1}}</td>
                                        <td>{{item.itemName}}</td>
                                        <td>{{item.itemQuantity}}</td>
                                        <td>{{item.remarks}}</td>
                                        <td>
                                            <md-button class="md-icon-button md-raised md-dense"
                                                @click="viewModalPage(item.poItemId)">
                                                <md-icon>edit</md-icon>
                                            </md-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <hr class="hr-s" />
                </div>
                <b-row class="mt-5">
                    <b-col md="1">
                        <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="addRefuelStation" id="addButtonLoader">{{editVar.Inputval}}</md-button>
                        <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </b-col>
                    <!-- <b-col md="2"  v-if="itemArrayShow.length > 0 && UserPermission == 'Yes'">
                        <model-list-select
                          :list="ApproveList"
                          v-model="stockInDetails.on_approve"
                          option-value="Listinv"
                          option-text="Listint"
                          placeholder="Select Status"
                        ></model-list-select>
                    </b-col> -->
                </b-row>
            </md-card-content>
        </md-card>

        <!-- Item Modal Added By Shreshth Gahlot Start -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="Item-modal" hide-footer title="Add Item Name">
            <b-row class="justify-content-center">
                <b-col md="1"></b-col>
                <b-col md="4">
                    <label>Item Name <span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" id="itemNameValue" name="itemNameValue"
                        v-model="itemMaster.itemNameValue"></b-form-input>
                    <span class="error" v-if="!itemMaster.itemNameValue">{{ itemMasterErrorList.itemNameValue }}</span>
                </b-col>
                <b-col md="3">
                    <label>Item Code <span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" id="itemCodeValue" name="itemCodeValue"
                        v-model="itemMaster.itemCodeValue"></b-form-input>
                    <span class="error" v-if="!itemMaster.itemCodeValue">{{ itemMasterErrorList.itemCodeValue }}</span>
                </b-col>
                <b-col md="3" class="text-center">
                    <b-button style="margin-top:37px;" variant="outline-primary" @click="addItemMaster"
                        id="addButtonLoader" size="sm">Save</b-button>
                    <b-button style="margin-top:37px;" variant="outline-danger" class="ml-2" size="sm"
                        @click="hideItemType">Close</b-button>
                    <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
            </b-row>
        </b-modal>
        <!-- Item Modal Added By Shreshth Gahlot End -->

        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"
            @close="onClose"></md-dialog-alert>

        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop1"
            @close="onClose1"></md-dialog-alert>
        <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop2"></md-dialog-alert>
    </div>
</template>
  
  
<script>
    import DatePicker from "vue2-datepicker";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
    import { DateFormat, selectDateFormat} from "../../../helper/filters.js";
    import { globalPermissionStatus } from "../../../helper/collection.js";
    import MaintenanceService from "../../../services/MaintenanceService";
  
    export default {
        beforeMount() {
            if (globalPermissionStatus("Maintanence")) {
                this.$store.dispatch("setCurrentRoute", "/ResOfQuo/addResOfQuo");
                this.getData();
            } else {
                this.$router.push({
                    path: "/dashboard"
                });
            }
        },
        data() {
            return {
                itemMaster: {
                    itemId: "",
                    itemNameValue: "",
                    itemCodeValue: "",
                    TypeofAdd: "Item Master Add",
                },
                itemMasterError: [
                    "Please Enter Item Name",
                    "Please Enter Item Code",
                ],
                itemMasterErrorList: {
                    itemNameValue: "",
                    itemCodeValue: "",
                },
                CurrencyList: [],
                selectDateFormat,
                docURL: URL_BASE_DOC,
                isLoading: false,
                itemMasterAll: {},

                permissionStatus:
                    this.$sessionsStorage.get("PermissionStatus") != "" &&
                    this.$sessionsStorage.get("PermissionStatus") &&
                    this.$sessionsStorage.get("PermissionStatus") == "Read"
                    ? true
                    : false,
                alert: {
                    content:
                    this.$sessionsStorage.get("editROQId") != "" &&
                    this.$sessionsStorage.get("editROQId") != undefined
                        ? "Data Updated Succesfully"
                        : "Added Succesfully",
                    ok: "ok"
                },
                itemModal: {
                    itemQuantityUnit: "",
                    itemId: "",
                    poItemId: "",
                    itemNameCode: "",
                    RQ_ID: "",
                    itemCode: "",
                    itemName: "",
                    itemQuantity: "",
                    remarks: "",
                },
                stockInDetails: {
                    RQ_ID: "",
                    poItemId: "",
                    itemCode: "",
                    itemName: "",
                    itemQuantity: "",
                    totalAmount: "",
                    ratePerUnit: "",
                    location: "",
                    fk_currency_id: "2",
                    isReseAndQuoActive: false,
                    on_approve: '0',
                },
                itemModelError: [
                    "Please Select Item Code",
                    "Please Enter Item Quantity",
                ],
                itemModelErrorList: {
                    itemName: "",
                    itemQuantity: "",
                },
                ApproveList: [
                    {
                        Listinv: "1",
                        Listint: "Approve",
                    },
                    {
                        Listinv: "0",
                        Listint: "Reject",
                    }
                ],
                UserPermission: "",
                validate: true,
                validateAddItem: true,
                maintenanceTypeError: "",
                locationError: "",
                addedByPersonError: "",
                RFQPdf:"",

                poDateError: "",
                vendorNamError: "",
                employeeMaster: [
                    {
                    employeeName: "ajit"
                    }
                ],
                locationMaster: [
                    {
                    pickupLocation: "mumbai"
                    }
                ],
                vendorMaster: ["abc"],

                itemDetail: [
                    {
                    itemCode: "ajit"
                    }
                ],
                locationDetail: [{}],
                dapartmentDetail: [],
                vendorDetail: [],
                itemArrayShow: [],
                itemNameError: "",
                ratePerUnitError: "",
                itemQuantityError: "",
                itemCodeError: "",

                editVar: {
                Inputval:
                    this.$sessionsStorage.get("editROQId") != "" &&
                    this.$sessionsStorage.get("editROQId") != undefined
                    ? "Update"
                    : "Submit"
                }
            };
        },
        watch: {
            itemMasterAll: {
                handler: function(newVal, oldVal) {
                this.findItemCode(newVal);
                },
                deep: true
            }
        },
        mounted() {
            // this.JqueryFun();
        },
        beforeDestroy() {},
        destroyed() {},
        components: {
            DatePicker,
            ModelListSelect,
            // Loading,
            CustomLoader,
            MaintenanceService,
        },
        computed: {  
            itemMasterList() {
                return this.itemDetail;
            },
            locationMasterList() {
                return this.locationMaster;
            },
        },
        methods: {
            doLoading() {
                this.isLoading = true;
            },
            doLoadingClose() {
                this.isLoading = true;
        
                setTimeout(() => {
                this.isLoading = false;
                }, 500);
            },
            finalAmount(itemQuantityUnit) {
                let amount = parseFloat(this.stockInDetails.itemQuantity) * parseFloat(itemQuantityUnit);
                this.stockInDetails.totalAmount = amount;
            },
            validateModal() {
                let validate_new = true;
        
                if (this.stockInDetails.itemQuantity == "") {
                $("#itemQuantity").focus();
                this.itemQuantityError = "Enter Quantity ";
                validate_new = false;
                }
                if (validate_new != true) {
                this.validate = false;
                } else {
                this.validate = true;
                }
            },
            previousPoView() {
                this.$router.push({
                    path: "/ResOfQuo/ResOfQuo"
                });
            },
            findItemCode(item) {
                this.itemModal.itemName = item.itemName;
                this.itemModal.itemCode = item.itemCode;
                this.itemModal.itemId = item.itemId;
            },
            viewModalPage(itemID) {
                let array = this.itemArrayShow.filter(x => {
                    return x.poItemId == itemID;
                });

                Object.keys(this.itemModal).map(x => {
                    this.itemModal[x] = array[0][x] || "";
                });
                this.itemModal.dummyItemName =
                    array[0].itemName + "-" + array[0].itemCode;
            },
            getData() {
                let payload = {
                    itemCode: "itemCode",
                    serviceEstimationId: ""
                };
                MaintenanceService.fetchToStockIn(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    console.log("Shreshth Gahlot data fetchInStock => ", data);
                    if ( status == 200 && data) {
                        if (data.itemDetail.length > 0) {
                        this.itemDetail = data.itemDetail;
                        } else {
                        this.itemDetail = [];
                        }
                        console.log("Shreshth Gahlot data.locationMaster => ", data.locationMaster);
                        if (data.locationMaster.length > 0) {
                            this.locationMaster = data.locationMaster;
                        }
                        this.viewStockDetail();
                    }
                })
                .catch(error => {});
            },
            activatestockInDetails() {
                if (
                    this.stockInDetails.isReseAndQuoActive == 1 ||
                    this.stockInDetails.isReseAndQuoActive == true
                ) {
                    this.stockInDetails.isReseAndQuoActive = false;
                } else if (
                    this.stockInDetails.isReseAndQuoActive == 0 ||
                    this.stockInDetails.isReseAndQuoActive == false
                ) {
                    this.stockInDetails.isReseAndQuoActive = true;
                }
            },

            viewStockDetail() {
                let payload = {
                    itemCode: "Request_Edit_Data",
                    RQ_ID: this.$sessionsStorage.get("editROQId"),
                };
                console.log("Shreshth Gahlot Edit viewStockDetail => ", payload);
                MaintenanceService.EditDataMaintenance(payload)
                .then(result => {
                    const { statusText, status, data } = result;
                    if (status == 200 && data) {
                        this.UserPermission = data.MainPermission;
                        console.log("Shreshth Gahlot itemModal Payload => ", data.editJob[0]);
                        Object.keys(data.editJob[0]).map(x => {
                        this.stockInDetails[x] = data.editJob[0][x] || "";
                        });
                        this.stockInDetails.fk_poItemId += ",";

                        this.poItemView(this.stockInDetails.fk_poItemId);
                    }
                })
                .catch(error => {});
            },
            poItemView(poItemId) {
                let payload = {
                    poItemId: poItemId
                };

                payload["poOrderId"] = "";

                let options = {
                    method: "POST",
                    url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
                    data: JSON.stringify(payload),
                    crossDomain: true,

                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.$sessionsStorage.get("loginId")
                    }
                };

                axios(options)
                .then(result => {
                const { statusText, status, data } = result;
                if ( status == 200 && data) {
                    console.log("Shreshth Gahlot data.itemArray => ", data.itemArray);
                    if (data.itemArray.length > 0) {
                        this.itemArrayShow = data.itemArray;
                    }
                }
                })
                .catch(error => {});
            },
            validateItem() {
                let validate_new = true;
                Object.keys(this.itemModelErrorList).map((x, index) => {
                if (
                    this.itemModal[x] == "" ||
                    this.itemModal[x] == undefined ||
                    this.itemModal[x] == null
                ) {
                    this.itemModelErrorList[x] = this.itemModelError[index];
                    validate_new = false;
                }
                });
                if (validate_new != true) {
                    this.validateAddItem = false;
                    return;
                } else {
                    this.validateAddItem = true;
                }
            },
            addItem() {
                this.validateItem();
                if (this.validateAddItem != false) {
                    if (this.stockInDetails.RQ_ID != "") {
                        this.itemModal["RQ_ID"] = ""+this.stockInDetails.RQ_ID+"";
                    } else {
                        this.itemModal["RQ_ID"] = "";
                    }
                    let payload = {
                        itemModal: this.itemModal,
                        view : "Request_of_Quotation",
                    };
                    if (this.validate != false) {
                        let options = {
                            method: "POST",
                            url: `${URL_BASE}/Api_Maintenance/poItems.php`,
                            data: JSON.stringify(payload),
                            crossDomain: true,
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: this.$sessionsStorage.get("loginId")
                            }
                        };
                        console.log("Shreshth Gahlot options => ", options);
                        axios(options)
                        .then(result => {
                            const { statusText, status, data } = result;
                            if ( status == 200 && data) {
                            this.stockInDetails.poItemId += data.Id + ",";
                            this.UserPermission = data.MainPermission;

                            Object.keys(this.itemModal).map(x => {
                                this.itemModal[x] = "";
                            });
                            this.itemNameError = "";
                            this.itemCodeError = "";
                            this.ratePerUnitError = "";
                            this.itemQuantityError = "";

                            this.onClose1();
                            }
                        })
                        .catch(error => {});
                    }
                }
            },

            onClose(type) {
                this.$router.push({
                    path: "/ResOfQuo/addResOfQuo"
                });
            },

            onClose1() {
                this.itemArrayShow = [];
                let payload = {
                    poItemId: this.stockInDetails.poItemId,
                    view: "Request_Of_Quotation",
                };
                if (this.stockInDetails.RQ_ID != "") {
                    payload["fk_reqQuotationId"] = this.stockInDetails.RQ_ID;
                } else {
                    payload["fk_reqQuotationId"] = "";
                }

                let options = {
                    method: "POST",
                    url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
                    data: JSON.stringify(payload),
                    crossDomain: true,

                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.$sessionsStorage.get("loginId")
                    }
                };

                axios(options)
                .then(result => {
                const { statusText, status, data } = result;
                if ( status == 200 && data) {
                    if (data.itemArray.length > 0) {
                        this.itemArrayShow = data.itemArray;
                        this.isLoading = false;
                    }
                }
                })
                .catch(error => {});
            },
            
    
            addRefuelStation() {    
                if (this.validate != false) {
                    $("#addButtonLoader").css("display", "none");
                    $("#loader").css("display", "block");
                    let payload = {
                        itemCode: 'Add_RequestData',
                        StockDetails: this.stockInDetails,
                    };
                    console.log("Shreshth Gahlot Stock In Details payload => ", payload);
                    MaintenanceService.AddDataMaintenance(payload)
                    .then(result => {
                        console.log("Shreshth Gahlot Result => ", result);
                        const { statusText, status, data } = result;
                        console.log("Shreshth Gahlot Location ID = ", data.msg);
                        if ( status == 200 && data) {
                            this.stockInDetails.RQ_ID = data.Id;
                            if(data.PdfData !=''){
                                this.RFQPdf = data.PdfData;
                            }
                            $("#addButtonLoader").css("display", "block");
                            $("#loader").css("display", "none");
                            this.$refs["addPop"].open();
                        }
                    })
                        
                    .catch(error => {});
                }
            },
            // Added By Shreshth Gahlot Start
            openItemModal() {
                this.isLoading = false;
                this.$refs["Item-modal"].show();
            },
            hideItemType() {
                this.$refs["Item-modal"].hide();
                this.isLoading = false;
            },
            validateItemMaster() {
                let validate_new = true;
                Object.keys(this.itemMasterErrorList).map((x, index) => {
                if (
                    this.itemMaster[x] == "" ||
                    this.itemMaster[x] == undefined ||
                    this.itemMaster[x] == null
                ) {
                    this.itemMasterErrorList[x] = this.itemMasterError[index];
                    validate_new = false;
                }
                });
                if (validate_new != true) {
                this.validate = false;
                return;
                } else {
                this.validate = true;
                }
            },
            addItemMaster() {
                this.validateItemMaster();
                if (this.validate != false) {
                    let payload = {
                        itemMaster: this.itemMaster,
                        ModalAdd: "PO Order",
                    };
                    payload = JSON.stringify(payload);
                    console.log("Shreshth Gahlot => ", payload);
                    let options = {
                        method: "POST",
                        url: `${URL_BASE}/Api_Maintenance/addItem.php`,
                        data: payload,
                        crossDomain: true,
                        headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: this.$sessionsStorage.get("loginId")
                        }
                    };
                    axios(options)
                    .then(result => {
                    const { statusText, status, data } = result;
                    console.log("Shreshth Add Item Data ", data);
                    if (status == 200 && data) {
                        if(data.already) {
                            this.alert.content = "Item Already Exists";
                            this.$refs["addPop2"].open();
                            return false;
                        } else {
                            if (data.itemId) {
                                this.itemMasterList();
                            }
                            this.hideItemType();
                        }
                        this.getData();
                    }
                    })
                    .catch(error => {});
                }
            },
        }
    };
</script>
<style>
    .md-direction-bottom-right {width: 16% !important;}
    .b-form-input-container {margin: 4px 0 12px !important;}
    .activeClass {display: none;}
    .error {color: red;}
    .md-dialog-container.HereDialog.md-theme-default {z-index: 9999999;}
    .md-dialog-container.md-active{z-index: 9999999;}
    .md-dialog-container.HereDialog.md-theme-default .md-dialog {width: 50%;height: 50%;}
    .md-select-content {z-index: 999999999;}
    .marg-top {margin-top: 0%;}
    .md-card .md-card-content:last-child{height: 85vh;}
    @media (min-width:320px) and (max-width:767px) {
        .mobile-width{min-width: 100%;display:inline-block;}
        .md-card .md-card-content:last-child{height: auto !important;}
    }
</style>


// WEBPACK FOOTER //
// addResOfQuo.vue?0673914e